import React, { useMemo } from 'react';
import PeriodFlowOverview from '../charts/PeriodFlowOverview';

const isClp = (value) => {
  const code = String(value || 'CLP').trim().toUpperCase();
  return !code || code === 'CLP';
};

const TreasuryOverview = ({
  entries = [],
  accounts = [],
  selectedPeriod = null,
  chartColumns = null,
  periodFilter = 'last_36',
  periodTitle = '',
  isDarkMode = false,
  ui,
  loading = false,
  children = null,
}) => {
  const clpAccounts = useMemo(
    () => (accounts || []).filter((account) => isClp(account.currency)),
    [accounts]
  );
  const otherCurrencyCount = (accounts || []).length - clpAccounts.length;
  const clpAccountIds = useMemo(() => new Set(clpAccounts.map((account) => Number(account.id))), [clpAccounts]);
  const flowRows = useMemo(
    () =>
      (entries || [])
        .filter((row) => {
          if (row.account_id != null && clpAccountIds.size) return clpAccountIds.has(Number(row.account_id));
          return isClp(row.currency);
        })
        .map((row) => {
          const amount = Math.abs(Number(row.amount || 0));
          const income = String(row.entry_type || '') === 'income';
          const reconciled = String(row.reconciliation_status || '') === 'Conciliado';
          return {
            date: row.entry_date,
            income: income ? amount : 0,
            expense: income ? 0 : amount,
            extraAmount: reconciled ? amount : 0,
            extraCount: reconciled ? 1 : 0,
          };
        }),
    [entries, clpAccountIds]
  );

  const openingBalance = useMemo(
    () => clpAccounts.reduce((sum, account) => sum + Number(account.initial_balance || 0), 0),
    [clpAccounts]
  );

  return (
    <PeriodFlowOverview
      flowRows={flowRows}
      openingBalance={openingBalance}
      selectedPeriod={selectedPeriod}
      chartColumns={chartColumns}
      periodFilter={periodFilter}
      periodTitle={periodTitle}
      lineTitle="Saldo total en cuentas"
      hoverPositiveLabel="Ingresos"
      hoverNegativeLabel="Egresos"
      totalLabel="Saldo total"
      positiveLabel="Ingresos"
      negativeLabel="Egresos"
      extraLabel="Conciliado"
      extraMetric="extraAmount"
      extraHint={(current) =>
        `${current.extraCount.toLocaleString('es-CL')} de ${current.count.toLocaleString('es-CL')} movimientos · ${
          current.count
            ? ((current.extraCount / current.count) * 100).toLocaleString('es-CL', { maximumFractionDigits: 0 })
            : 0
        }%`
      }
      footnote={otherCurrencyCount ? `${otherCurrencyCount} cuenta(s) en otra moneda no incluidas` : ''}
      isDarkMode={isDarkMode}
      ui={ui}
      loading={loading}
    >
      {children}
    </PeriodFlowOverview>
  );
};

export default TreasuryOverview;
